import * as R from 'ramda';

export default function ParentListItemDirective() {
  return {
    template: require('./parent-list-item.html'),
    restrict: 'E',
    scope: {
      canExpand: '<',
      flexActions: '<',
      flexSummary: '<',
      flexTitle: '<',
      isExpanded: '<',
      level: '<',
      listTitle: '@',
      listTitleCssOverride: '@',
      listTitleHighlightText: '=',
      onExpand: '&', // Must return a promise
      ssTooltipAppendToSelector: '@',
      listHelpToolTip: '<',
    },
    transclude: {
      actions: '?actions',
      expandIcon: '?expandIcon',
      expandPanel: '?expandPanel',
      summary: '?summary',
    },
    link: (scope, attrs, el) => { // eslint-disable-line no-unused-vars
      if (R.isNil(scope.parentListItemVM.flexTitle)) {
        scope.parentListItemVM.flexTitle = 45;
      }
      if (R.isNil(scope.parentListItemVM.flexSummary)) {
        scope.parentListItemVM.flexSummary = 45;
      }
      if (R.isNil(scope.parentListItemVM.flexActions)) {
        scope.parentListItemVM.flexActions = 10;
      }
      // switch (scope.parentListItemVM.level) {
      //   case 0:
      //     // Don't add a stylePrefix
      //     break;
      //   case 1:
      //     scope.parentListItemVM.stylePrefix = 'inner-';
      //     break;
      //   case 2:
      //     scope.parentListItemVM.stylePrefix = 'sub-inner-';
      //     break;
      //   case 3:
      //     scope.parentListItemVM.stylePrefix = 'inner-sub-inner-';
      //     break;
      //   case 4:
      //     scope.parentListItemVM.stylePrefix = 'sub-inner-sub-inner-';
      //     break;
      //   case 5:
      //     scope.parentListItemVM.stylePrefix = 'inner-sub-inner-sub-inner-';
      //     break;
      //   case 6:
      //     scope.parentListItemVM.stylePrefix = 'sub-inner-sub-inner-sub-inner-';
      //     break;
      //   default:
      //     scope.parentListItemVM.stylePrefix = '';
      // }
    },
    controller: 'ParentListItemController',
    controllerAs: 'parentListItemVM',
    bindToController: true,
    replace: true,
  };
}
